import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function BranchPage() {

  const [rows, setRows] = useState([]);
  const [companies, setCompanies] = useState([]);
  const location = localStorage.getItem('userLocation');
  const [data, setData] = useState({
    company: "",
    name: "",
    type: ""
  });

  useEffect(() => {
    fetchData();
    fetchCompanies();
  }, []);

  const fetchData = () => {
    axios.get(baseUrl + "branchs/")
      .then(res => {
        setRows(res.data);
      });
  };

  const fetchCompanies = () => {
    axios.get(baseUrl + 'view-hospital/' + location + '/')
      .then(res => {
        setCompanies(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    if (!data.company || !data.name || !data.type) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("company", data.company);
    _formData.append("name", data.name);
    _formData.append("type", data.type);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "branchs/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {

      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "Branch Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          company: "",
          name: "",
          type: ""
        });

        fetchData();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Something went wrong", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "branchs/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Branch deleted", "success");
            fetchData();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "company",
      headerName: "Company",
      flex: 1,
      renderCell: (params) => params.row.company?.company || "Unknown"
    },
    { field: "name", headerName: "Branch Name", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
    { field: "add_date", headerName: "Date", width: 120 },

    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/branchs/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning"
        >
          Edit
        </Link>
      ),
      width: 120
    },

    {
      field: "delete",
      headerName: "Action",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm ms-1"
        >
          <i className="fa-solid fa-trash-can"></i>
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form Card */}
      <div className="card p-4 mb-4">
        <h4>Add Branch</h4>

        <select
          className="form-control mt-3"
          name="company"
          value={data.company}
          onChange={inputHandler}
        >
          <option value="">Select Company</option>
          {companies.map(c => (
            <option key={c.id} value={c.id}>{c.company}</option>
          ))}
        </select>

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Branch Name"
          name="name"
          value={data.name}
          onChange={inputHandler}
        />

        <select
          className="form-control mt-3"
          name="type"
          value={data.type}
          onChange={inputHandler}
        >
          <option value="">Select Type</option>
          <option value="Warehouse">Warehouse</option>
          <option value="Production">Production</option>
          <option value="Truck">Truck</option>
        </select>

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default BranchPage;
